const fontSize = {
  xxs: '0.6875rem',
  xs: '0.75rem',
  s: '0.875rem',
  m: '1rem',
  l: '1.25rem',
  xl: '1.5rem',
  xxl: '1.75rem',
  xxxl: '2rem',
} as const;

const fontFamily = {
  regular: 'Inter, Red Hat Display, Sans-Serif',
} as const;

const fontWeight = {
  normal: 400,
  medium: 500,
  /** @deprecated use `medium` for 500 or `semiBold` for 600 */
  semibold: 500,
  semiBold: 600,
  bold: 700,
} as const;

const lineHeight = {
  xs: '1rem',
  s: '1.25rem',
  m: '1.5rem',
  l: '1.625rem',
  xl: '2rem',
  xxl: '2.25rem',
  xxxl: '2.5rem',
} as const;

const letterSpacing = {
  s: '0.01px',
  m: '0.32px',
} as const;

export const typography = {
  fontFamily,
  fontSize,
  fontWeight,
  lineHeight,
  letterSpacing,
} as const;
export type Typography = typeof typography;
